import { httpCreate } from './http';

const http = httpCreate('/srv/kuaishou');

export const kuaishou = {
	getBounds() {
		return http.get('/bounds');
	},
	unbind(kuaishouId) {
		return http.delete(`/unbind/${kuaishouId}`);
	},
};
